import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { DetailedCourse } from "@domain/lms/course/course";
import { AttachmentSection } from "@domain/lms/course/courseSection";
import { getAssetById } from "@domain/lms/course/utils";
import { Primary } from "@ui/components/containers/primary";
import { Secondary } from "@ui/components/containers/textBlocks";
import { FileIcon } from "@ui/components/icons";
import { gap } from "@ui/styles/utils";

interface AttachmentSectionViewProps extends React.HTMLAttributes<HTMLDivElement> {
	section: AttachmentSection;
	course: DetailedCourse;
}
export const AttachmentSectionView: React.FC<AttachmentSectionViewProps> = ({ section, course, ...htmlProps }) => {
	const asset = getAssetById(course.content, section.assetId);

	if (!asset) {
		return null;
	}
	return (
		<Container {...htmlProps}>
			<Primary>{I18n.t("course.section.attachment.title", { type: asset.mimeType.split("/")[1] })}</Primary>
			<Secondary>
				<a href={asset.url} target="_blank" rel="noreferrer">
					<FileIcon />
					{section.title || I18n.t("course.section.attachment.download")}
				</a>
			</Secondary>
		</Container>
	);
};

const Container = styled.div`
	${gap(16)};
	padding-left: 40px;
	@media (max-width: 900px) {
		padding-left: 20px;
	}
	${({ theme }) => theme.textStyles.primary};
	display: flex;
	flex-direction: column;
	align-items: flex-start;

	a {
		display: flex;
		align-items: center;
		svg {
			margin-right: 10px;
		}
	}
`;
